export const getRetrySupportState = () => ({
  attemptedPaymentMethods: {}
})

export const retrySupportActions = {
  /**
   * Add a payment method to the list of attempted payment methods
   * This is used to track which payment methods have been attempted by the user
   * and to prevent retries for methods that do not support it
   *
   * @since KJS-5987
   */
  addPaymentMethodAttempt({ dispatch, state }, method) {
    const attemptedMethods = state.smartForm.attemptedPaymentMethods
    if (!attemptedMethods[method]) {
      dispatch('update', {
        smartForm: {
          attemptedPaymentMethods: {
            ...attemptedMethods,
            [method]: true
          }
        }
      })
    }
  },
  /**
   * @since KJS-5987
   */
  removePaymentMethodAttempt({ dispatch, state }, method) {
    const attemptedMethods = state.smartForm.attemptedPaymentMethods
    if (attemptedMethods[method]) {
      dispatch('update', {
        smartForm: {
          attemptedPaymentMethods: {
            ...attemptedMethods,
            [method]: undefined
          }
        }
      })
    }
  },
  /**
   * Reset attempted payment methods
   * Since UPDATE mutation uses deep-extend, we need to explicitly
   * set all existing keys to undefined to clear them
   *
   * @since KJS-5728
   */
  resetAttemptedPaymentMethods({ dispatch, state }) {
    const currentMethods = state.smartForm.attemptedPaymentMethods
    const resetMethods = {}

    // Set all existing keys to undefined to remove them
    Object.keys(currentMethods).forEach(key => {
      resetMethods[key] = undefined
    })

    dispatch('update', {
      smartForm: {
        attemptedPaymentMethods: resetMethods
      }
    })
  }
}

export const retrySupportGetters = {
  hasPreventsRetry:
    ({ dna }) =>
    method => {
      return dna.smartForm?.[method]?.retrySupport === 'PREVENTS_RETRY'
    },
  shouldPreventRetry:
    ({ smartForm }, getters) =>
    method => {
      const attemptedMethods = smartForm?.attemptedPaymentMethods || {}
      return getters.hasPreventsRetry(method) && !!attemptedMethods[method]
    }
}
